import './twitter.css';

const React = require('react');
const { TwitterShareButton, TwitterIcon } = require('react-share');
const player = require('../../define/player').default;
const { getStageName } = require('../stageData').default;
const gameParamater = require('../../define/gameParamater').default;


const url = "https://abyss.souu-array1.site/";

const getPlayerImage = playerCharactor => {
    switch (playerCharactor) {
        // TODO: url
        case player.PLAYER_ROYAL_GUARD:
            return "https://pic.twitter.com/kytoL86hGb";
        case player.PLAYER_KAGEROU:
            return "https://pic.twitter.com/hLequQosDI";
        case player.PLAYER_SUMMONER:
            return "https://pic.twitter.com/O1YwIeu13a";
        default:
            return;
    }
}

const getStageClearTitle = (props) => {
    const { playerState: { playerName, playerCharactor }, gameState: { score, arrivalStage } } = props;
    return `${playerName}はステージ${arrivalStage}(${getStageName(arrivalStage)})まで到達しました！　スコア:${score}　#PorinBoxAbyss　${getPlayerImage(playerCharactor)}`;
}

const getGameClearTitle = (props) => {
    const { playerState: { playerName, playerCharactor }, gameState: { score } } = props;
    return `${playerName}は魔女を討伐し、全ステージをクリアしました！　スコア:${score}　#PorinBoxAbyss　${getPlayerImage(playerCharactor)}`;
}

const getTwitterText = (props) => {
    const { gameState: { isGameClear } } = props;
    if (isGameClear) {
        return getGameClearTitle(props);
    }
    return getStageClearTitle(props);
}

const renderTwitterButton = (title) => {
    if (gameParamater.USE_TWITTER) {
        return (
            <TwitterShareButton title={title} url={url}>
                <div className="twitter-button" >
                    Twitterで攻略状態を共有しよう！
                    <TwitterIcon size={40} round />
                </div>
            </TwitterShareButton>
        )
    } else {
        return;
    }
}

export default {
    getPlayerImage,
    getStageClearTitle,
    getGameClearTitle,
    getTwitterText,
    renderTwitterButton,
    url
}